/** Configuration read from the build environment (VITE_* variables). appsDomain and builderUrl are local dev overrides only. */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  release: import.meta.env.VITE_RELEASE ?? 'local',
  appsDomain: import.meta.env.VITE_APPS_DOMAIN ?? '',
  builderUrl: (import.meta.env.VITE_BUILDER_URL ?? '').replace(/\/$/, ''),
};
